// Appends an action (verse searched, song shown, ...) to the current login
// session's activity list, which the admin dashboard reads. Does nothing when
// no session is active. The same entry is queued for the central usage log.
import usageSync from '../services/usageSync';

export function logActivity(activityType, details = {}) {
  const currentSessionId = localStorage.getItem('currentSessionId');
  if (!currentSessionId) return;

  usageSync.enqueue('activity', activityType, details, currentSessionId);

  const sessions = JSON.parse(localStorage.getItem('sleekHearSessions') || '[]');
  const updatedSessions = sessions.map(session => {
    if (session.id === currentSessionId) {
      const activities = session.activities || [];
      activities.push({
        type: activityType,
        details,
        timestamp: new Date().toISOString()
      });
      return { ...session, activities, lastActivity: new Date().toISOString() };
    }
    return session;
  });
  localStorage.setItem('sleekHearSessions', JSON.stringify(updatedSessions));
}
